var Vendd = (function (Vendd) {
    'use strict';

    Vendd.RequestOffer = (function (RequestOffer) {

        RequestOffer.Messages = (function (Messages) {

        Messages.SearchForProducts = function (searchTerm) {
            var data = {
                searchTerm: searchTerm
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SearchForProducts", data);
        };
        Messages.SearchForProducts.className = "Vendd.RequestOffer.Messages.SearchForProducts";

        Messages.SearchForProductsSuccess = function (model) {
            var data = {
                model: model
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SearchForProductsSuccess", data);
        };
        Messages.SearchForProductsSuccess.className = "Vendd.RequestOffer.Messages.SearchForProductsSuccess";

        Messages.SearchForProductsFailed = function (response) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SearchForProductsFailed", response);
        };
        Messages.SearchForProductsFailed.className = "Vendd.RequestOffer.Messages.SearchForProductsFailed";
   		
        Messages.AddOfferProducts = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.AddOfferProducts", data);
        };
        Messages.AddOfferProducts.className = "Vendd.RequestOffer.Messages.AddOfferProducts";

        Messages.AddOfferProductsSuccess = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.AddOfferProductsSuccess", data);
        };
        Messages.AddOfferProductsSuccess.className = "Vendd.RequestOffer.Messages.AddOfferProductsSuccess";

        Messages.AddOfferProductsFailure = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.AddOfferProductsFailure", data);
        };
        Messages.AddOfferProductsFailure.className = "Vendd.RequestOffer.Messages.AddOfferProductsFailure";

        Messages.GetPendingRequestsOffer = function (offerid, pageSize, pageNum) {
            var data = {
                offerid: offerid,
                pageSize: pageSize,
                pageNum: pageNum
            };
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.GetPendingRequestsOffer", data);
        };
        Messages.GetPendingRequestsOffer.className = "Vendd.RequestOffer.Messages.GetPendingRequestsOffer";

        Messages.GetPendingRequestsOfferSuccess = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.GetPendingRequestsOfferSuccess", data);
        };
        Messages.GetPendingRequestsOfferSuccess.className = "Vendd.RequestOffer.Messages.GetPendingRequestsOfferSuccess";

        Messages.GetPendingRequestsOfferFailure = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.GetPendingRequestsOfferFailure", data);
        };
        Messages.GetPendingRequestsOfferFailure.className = "Vendd.RequestOffer.Messages.GetPendingRequestsOfferFailure";

        Messages.UpdateRequestOfferProducts = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.UpdateRequestOfferProducts", data);
        };
        Messages.UpdateRequestOfferProducts.className = "Vendd.RequestOffer.Messages.UpdateRequestOfferProducts";

        Messages.UpdateRequestOfferProductsSuccess = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.UpdateRequestOfferProductsSuccess", data);
        };
        Messages.UpdateRequestOfferProductsSuccess.className = "Vendd.RequestOffer.Messages.UpdateRequestOfferProductsSuccess";

        Messages.UpdateRequestOfferProductsFailure = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.UpdateRequestOfferProductsFailure", data);
        };
        Messages.UpdateRequestOfferProductsFailure.className = "Vendd.RequestOffer.Messages.UpdateRequestOfferProductsFailure";

        Messages.DeleteRequestOffer = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.DeleteRequestOffer", data);
        };
        Messages.DeleteRequestOffer.className = "Vendd.RequestOffer.Messages.DeleteRequestOffer";

        Messages.DeleteRequestOfferSuccess = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.DeleteRequestOfferSuccess", data);
        };
        Messages.DeleteRequestOfferSuccess.className = "Vendd.RequestOffer.Messages.DeleteRequestOfferSuccess";

        Messages.DeleteRequestOfferFailure = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.DeleteRequestOfferFailure", data);
        };
        Messages.DeleteRequestOfferFailure.className = "Vendd.RequestOffer.Messages.DeleteRequestOfferFailure";

        Messages.SubmitRequestOffer = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SubmitRequestOffer", data);
        };
        Messages.SubmitRequestOffer.className = "Vendd.RequestOffer.Messages.SubmitRequestOffer";

        Messages.SubmitRequestOfferSuccess = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SubmitRequestOfferSuccess", data);
        };
        Messages.SubmitRequestOfferSuccess.className = "Vendd.RequestOffer.Messages.SubmitRequestOfferSuccess";

        Messages.SubmitRequestOfferFailure = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.SubmitRequestOfferFailure", data);
        };
        Messages.SubmitRequestOfferFailure.className = "Vendd.RequestOffer.Messages.SubmitRequestOfferFailure";

        Messages.ImportRequestOfferExcel = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.ImportRequestOfferExcel", data);
        };
        Messages.ImportRequestOfferExcel.className = "Vendd.RequestOffer.Messages.ImportRequestOfferExcel";

        Messages.ImportRequestOfferExcelSuccess = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.ImportRequestOfferExcelSuccess", data);
        };
        Messages.ImportRequestOfferExcelSuccess.className = "Vendd.RequestOffer.Messages.ImportRequestOfferExcelSuccess";

        Messages.ImportRequestOfferExcelFailure = function (data) {
            Vendd.MessageBus.VenddMessage.call(this, "Vendd.RequestOffer.Messages.ImportRequestOfferExcelFailure", data);
        };
        Messages.ImportRequestOfferExcelFailure.className = "Vendd.RequestOffer.Messages.ImportRequestOfferExcelFailure";

        return Messages;

    })(RequestOffer.Messages || {});

        return RequestOffer;

    })(Vendd.RequestOffer || {});

return Vendd;

})(Vendd || {});